import React, { ReactNode, createContext, useContext, useMemo, useState } from 'react';

import { useSearchParams } from 'react-router-dom';

interface CustomFundLineupContextValue {
  returnTo: string;
}

const CustomFundLineupContext = createContext<CustomFundLineupContextValue>({
  returnTo: '',
});

interface CustomFundLineupProviderProps {
  children: ReactNode;
}

export const CustomFundLineupProvider: React.FC<CustomFundLineupProviderProps> = ({ children }) => {
  const [searchParams] = useSearchParams();

  const [returnTo] = useState<string>(() => searchParams.get('return_to') || '');

  const value: CustomFundLineupContextValue = useMemo(
    () => ({
      returnTo,
    }),
    [returnTo]
  );

  return <CustomFundLineupContext.Provider value={value}>{children}</CustomFundLineupContext.Provider>;
};

export const useCustomFundLineup = (): CustomFundLineupContextValue => {
  return useContext(CustomFundLineupContext);
};
